import { SearchIcon } from "lucide-react";
import { useInstantSearch } from "react-instantsearch";

import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";
import {
  AlertRebrand,
  AlertRebrandDescription,
  AlertRebrandTitle,
} from "@tudigo-monorepo/web-tudigo-components";

import { SuggestedProjects } from "./suggested-projects";

export function EmptySearchResults() {
  const { results } = useInstantSearch();
  const { t } = useTranslation();

  return (
    <section className="mb-6 flex flex-col gap-y-10">
      <AlertRebrand variant="error">
        <AlertRebrandTitle>
          <SearchIcon className="h-5 w-5" />
          {t("search_projects_page.financed.empty_results.alert.label", {
            query: results.query,
          })}
        </AlertRebrandTitle>
        <AlertRebrandDescription>
          {t("search_projects_page.financed.empty_results.alert.description")}
        </AlertRebrandDescription>
      </AlertRebrand>
      <div className="flex flex-col">
        <h2 className="font-roobert mb-6 text-2xl font-semibold">
          {t(
            "search_projects_page.financed.empty_results.suggested_projects.title",
          )}
        </h2>
        <SuggestedProjects />
      </div>
    </section>
  );
}
